import React from "react";

export default function DisplayBooks({ userData }) {
	return (
		<div className="mb-3">
			<p className="mt-2">
				<i className="bi bi-book"></i> <span>Books</span>
			</p>

			{userData?.books?.map((book, i) => (
				<span key={i} className="badge custom-badge rounded-pill text-bg-secondary me-2 mb-1">
					<i className="bi bi-book"></i> {book}
				</span>
			))}

			{!userData?.books?.length && <div>(Add books you've enjoyed)</div>}
		</div>
	);
}
